/**
 * The cube key an exclusion rule's conditions are read against, computed on
 * the CLIENT — mirrors the backend's excludeGroupCubeKey/rulesCubeLookupKey
 * pair: the group's own window when set (preset id, or `custom:from:to`),
 * else the first applicable formula group's window (a custom formula window
 * keys by GROUP ID), else the default rules range. Used only to pick real
 * numbers for the live example, so a mismatch degrades to "no example" —
 * never to wrong numbers.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowLayer, FormulaGroup } from '@trafficpulse/shared';

const DEFAULT_RULES_RANGE = 'last-7-days';

export interface GroupWindowFields {
  dateRange?: string;
  dateRangeCustomFrom?: string;
  dateRangeCustomTo?: string;
}

function ownKey(g: GroupWindowFields): string | null {
  if (!g.dateRange) return null;
  if (g.dateRange !== 'custom') return g.dateRange;
  const { dateRangeCustomFrom: from, dateRangeCustomTo: to } = g;
  return from && to ? `custom:${from}:${to}` : null;
}

const appliesTo = (g: FormulaGroup, layer: FlowLayer): boolean =>
  !g.appliesTo?.length || g.appliesTo.includes(layer);

/** Key of the metrics bag `group`'s conditions read for `layer`. */
export function excludeGroupWindowKey(
  group: GroupWindowFields,
  formulaGroups: ReadonlyArray<FormulaGroup>,
  layer: FlowLayer,
): string {
  const own = ownKey(group);
  if (own) return own;
  const first = formulaGroups.find((g) => appliesTo(g, layer));
  if (!first) return DEFAULT_RULES_RANGE;
  return first.dateRange !== 'custom' ? first.dateRange : `custom:${first.id}`;
}
